// ** Router Import
import Router from './@data/router/Router';
import { ErrorBoundary } from './components/atoms/ErrorBoundary';

const App = () => (
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
);

export default App;
